// extracted by mini-css-extract-plugin
export default {"container":"CrochetLogo_container__mC05j","image":"CrochetLogo_image__AocQw"};